import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { ICustomerDetail_V3, Item } from "../customer/customerApi";
import { Phone } from "../selectOptions/selectOptionsApi";


export interface IPhone {
  categoryPhoneId: number
  phone: string,

}

//Quan hệ
// export interface IRelationship {
//   id: number;
//   username: string;
//   gender: number;
//   CCCD: string;
//   taxCode?: string
//   birthday: string;
//   email: string[];
//   address: string;
//   phone: IPhone[];
//   professionId: number;
//   professionTitle: string;
//   provinceId: number;
//   provinceTitle: string;
//   districtId: number;
//   districtTitle: string;
//   relativeId: number;
//   relativeTitle: string;
//   businessFieldId?: number
//   businessFieldTitle?: string
//   code: string
// }


export interface IRelationship_V2 {
  id: number
  code: string
  username: string
  isPrimary: number
  gender?: number
  CCCD?: number
  birthday?: string
  phone: IPhone[]
  professionId: number
  professionTitle: string
  relativeId: number
  relativeTitle: string
  email: string[]
  taxCode: string
  businessFieldId: number
}

export interface Field {
  fieldId?: number
  fieldLabel: string
  fieldCode: string
  value: any
  recordId?: number
  groupKey: any
  view?: boolean
}

export interface IRelativeCustomer {
  id: number
  code: string
  name: string
  fields: Field[]
  relativeId: number
  relativeTitle: string
}


export interface ICCCD {
  isPrimary: number
  identityType: number
  name: string
}

//Danh sách người liên hệ khách hàng.
export const getlistRelativeCustomer = async (
  id: number, businessCheck: 0 | 1,
  limit?: number, pageNumber?: number, search?: string, unitId?: number[]
) => {
  const path = "/relatives/listRelativeCustomerV2"
  const params = {
    id, businessCheck,
    limit, pageNumber, search, unitId
  }
  const result: ResponseSuccessTotal<IRelativeCustomer[]> = await axiosClient.get(path, { params });
  return result;
};

//Thông tin chi tiết mối quan hệ
export const getInfoRelativeCustomer = async (id: number, customerId: number) => {
  const path = "/relatives/infoRelativeCustomer"
  const params = {
    id, customerId
  }
  const result: ResponseSuccess<IRelationship_V2> = await axiosClient.get(path, { params });
  return result;
};

// Thêm mới người liên hệ của khách hàng
export const addRelativeCustomer = async (
  username: string, gender: number, statusMarital: number, professionId: number, birthday: string, phone: IPhone[], provinceId: number, districtId: number, CCCD: string, email?: string, address?: string, image?: File | null, groupCustomerId?: number[], hobbyId?: number[], isRelative?: number, customerId?: number, relativeId?: number, unitTempId?: number


) => {
  const url = `/customer/addCustomer`;
  const params = {
    username, CCCD, gender, statusMarital, professionId, birthday, phone, provinceId, districtId, email, address, image, groupCustomerId, hobbyId, isRelative, customerId, relativeId, unitTempId

  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

// Thêm mới người liên hệ của khách hàng
export const addRelativeCustomer_V2 = async (
  username: string, gender: number, statusMarital: number, phone: IPhone[], provinceId: number, districtId: number, CCCD?: string, email?: string, address?: string, image?: File | null, groupCustomerId?: number[], hobbyId?: number[], isRelative?: number, customerId?: number, relativeId?: number, professionId?: number, birthday?: string, unitTempId?: number


) => {
  const url = `/customer/addCustomer`;
  const params = {
    username, CCCD, gender, statusMarital, professionId, birthday, phone, provinceId, districtId, email, address, image, groupCustomerId, hobbyId, isRelative, customerId, relativeId, unitTempId

  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

// Thêm mới người liên hệ của khách hàng
export const addRelativeCustomer_V3 = async (
  businessCheck: number, username: string, phone: IPhone[],
  gender?: number, statusMarital?: number, provinceId?: number, districtId?: number,
  CCCD?: string, email?: string, address?: string, image?: File | null,
  groupCustomerId?: number[], hobbyId?: number[], isRelative?: number,
  customerId?: number, relativeId?: number, professionId?: number,
  birthday?: string, unitTempId?: number, taxCode?: string,
  businessFieldId?: number, foundingDate?: string, listTypes?: number[]

) => {
  const url = `/customer/addCustomer`;
  const params = {
    businessCheck, username, phone, identityType: 0,
    gender, statusMarital, provinceId, districtId,
    CCCD, email, address, image,
    groupCustomerId, hobbyId, isRelative,
    customerId, relativeId, professionId,
    birthday, unitTempId, taxCode,
    businessFieldId, foundingDate, listTypes

  }
  const result: ResponseSuccess<ICustomerDetail_V3> = await axiosClient.post(
    url, params
  );
  return result;
}

// Thêm mới người liên hệ của khách hàng
export const addRelativeCustomer_V4 = async (
  businessCheck: number, username: string, phone: IPhone[], informationChannel?: string,
  type?: number, unitTempId?: number, CCCD?: ICCCD[], gender?: number,
  statusMarital?: number, listTypes?: number[], professionId?: number, birthday?: string,
  email?: string[], contactMethod?: number[], carLine?: number, address?: any[],
  image?: File | null, groupCustomerId?: number[], hobbyId?: number[], isRelative?: number,
  customerId?: number, relativeId?: number, description?: string, taxCode?: string,
  foundingDate?: string, businessFieldId?: number, personContactId?: number,
) => {
  const url = `/customer/addCustomer`;
  const params = {
    businessCheck, username, phone, informationChannel,
    type, unitTempId, CCCD, gender,
    statusMarital, listTypes, professionId, birthday,
    email, contactMethod, carLine, address,
    image, groupCustomerId, hobbyId, isRelative,
    customerId, relativeId, description, taxCode,
    foundingDate, businessFieldId, personContactId
  }
  const result: ResponseSuccess<ICustomerDetail_V3> = await axiosClient.post(
    url, params
  );
  return result;
}

//Xóa mối quan hệ khách hàng
export const updateRelativeCustomer_V3 = async (
  id: number, businessCheck: number, username: string, phone: IPhone[],
  gender?: number, statusMarital?: number, provinceId?: number, districtId?: number,
  CCCD?: string, email?: string, address?: string, image?: File | null,
  groupCustomerId?: number[], hobbyId?: number[],
  relativeId?: number, professionId?: number,
  birthday?: string, unitTempId?: number, taxCode?: string,
  businessFieldId?: number, foundingDate?: string, listTypes?: number[]

  ,
) => {
  const url = `/customer/editCustomer`;
  const params = {
    id, businessCheck, username, phone, identityType: 0,
    gender, statusMarital, provinceId, districtId,
    CCCD, email, address, image,
    groupCustomerId, hobbyId,
    relativeId, professionId,
    birthday, unitTempId, taxCode,
    businessFieldId, foundingDate, listTypes
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}

// Thêm mới người liên hệ của khách hàng
export const updateRelativeCustomer_V4 = async (
  id: number, businessCheck: number, username: { username: string, isPrimary: number }[], phone: IPhone[],
  type?: number, CCCD?: ICCCD[], gender?: number,
  statusMarital?: number, listTypes?: number[], professionId?: number, birthday?: string,
  email?: string[], contactMethod?: number[], carLine?: number, address?: any[],
  image?: File | null, groupCustomerId?: number[], hobbyId?: number[],
  customerId?: number, relativeId?: number, description?: string, taxCode?: string,
  foundingDate?: string, businessFieldId?: number
) => {
  const url = `customer/editCustomer`;
  const params = {
    id, businessCheck, username, phone,
    type, CCCD, gender,
    statusMarital, listTypes, professionId, birthday,
    email, contactMethod, carLine, address,
    image, groupCustomerId, hobbyId,
    customerId, relativeId, description, taxCode,
    foundingDate, businessFieldId
  }
  // const result: ResponseSuccess<ICustomerDetail_V3> = await axiosClient.put(
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}


//Xóa mối quan hệ khách hàng
export const deleteRelativeCustomer = async (
  id: number
) => {
  const url = `/customer/deleteCustomer`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}
//Xóa mối quan hệ khách hàng
export const deleteRelativeCustomerChild = async (
  customerId: number, relativeId: number
) => {
  const url = `relatives/deleteRelativeCustomer`;
  const params = {
    customerId, relativeId
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}




